
import React from "react";
import { ReactComponent as SearchIcon } from "../../assets/images/TicketImages/no-agent.svg";

const NoSearch = ({ title, description,titleFontSize ,descriptionFontSize}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "10px 32px 25px 32px",
      }}
    >
      <SearchIcon />
      <div style={{ height: 16 }} />
      <div
        style={{
          color: "#061522",
          textAlign: "center",
          fontFamily: "Inter",
          fontSize: titleFontSize || 18,
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "18px",
        }}
      >
        {title}
      </div>
      <div style={{ height: 8 }} />
      <div
        style={{
          color: "#405261",
          textAlign: "center",
          fontFamily: "Inter",
          fontSize: descriptionFontSize || 14,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "18px",
        }}
      >
        {description}
      </div>
    </div>
  );
};

export default NoSearch;
